module.exports = __webpack_public_path__ + "img/20240531_4.16d31905.jpg";